var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCircleCheckIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  className: "design-iconfont",
  viewBox: "0 0 42 42",
  width: "1em",
  height: "1em"
}, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "a",
  x1: "16.467%",
  x2: "82.211%",
  y1: "13.981%",
  y2: "80.314%"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "#FFE8C0"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopColor: "#FFFBF1"
})))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  fill: "url(#a)",
  d: "M21 0a21 21 0 1 0 0 42 21 21 0 1 0 0-42"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FF5800",
  fillRule: "nonzero",
  d: "M10.23 23.753a.677.677 0 0 1-.068-.948l.451-.547a.82.82 0 0 1 1.08-.144l4.978 3.392a1.66 1.66 0 0 0 1.898-.036l13.916-10.31a.83.83 0 0 1 1.028.04l.244.214a.68.68 0 0 1 .028 1.017l-.028.027-15.02 13.146a1.65 1.65 0 0 1-2.177-.026l-6.333-5.825z"
}))));
export default SvgCircleCheckIcon;